import { File02 } from '@/components/common/icons';
import { LinkText, Text } from '@/components/common/Typography';

const BlogLink = ({ href, children }: { href: string; children: string }) => {
    return (
        <LinkText color="textMuted" fontSize="sm" href={href} target="_blank">
            <File02 />
            <Text as="span" ml={2} fontSize="sm">
                {children}
            </Text>
        </LinkText>
    );
};

export default BlogLink;
